// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contratMesO[data-v-2527791e] {\n  display: flex;\n  margin-bottom: 10px;\n  flex: 1;\n  justify-content: space-between;\n}\n.contratMesO .m-r-20[data-v-2527791e] {\n    width: 25%;\n}\n.contratMesO .m-r-20 span[data-v-2527791e] {\n      font-weight: 600;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
